import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/autoplay";
import styles from "./style.module.css";
import { Autoplay, EffectCoverflow } from "swiper/modules";
import CardData from "./CardData";
import { Link } from "react-router-dom";
import { scrollToTop } from "../constent/helper";

function Cardslider() {
  return (
    <div className="hero-marquee px-[16px] lg:mt-[50px] md:mt-[24px] mt-[16px]">
      <Swiper
        effect="coverflow"
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        grabCursor={true}
        centeredSlides={true}
        loop={true}
        slidesPerView={"auto"}
        initialSlide={2} // Start at 3rd card
        coverflowEffect={{
          rotate: 0,
          stretch: 0,
          depth: 120,
          modifier: 2.5,
        }}
        modules={[Autoplay, EffectCoverflow]}
        className={styles.swiper_container}
      >
        {CardData.map((data, index) => (
          <SwiperSlide key={index} className={styles.swiper_slide}>
            <div className="relative flex justify-center">
              <img
                src={data.src}
                className={styles.swiper_slide_img}
                alt={data.text}
              />
              <div 
                className="absolute w-full h-full" 
                style={{
                  background: 'linear-gradient(180deg, rgba(0, 0, 0, 0.014) 0%, rgba(0, 0, 0, 0.112) 15%, rgba(0, 0, 0, 0.21) 29%, rgba(0, 0, 0, 0.357) 50%, rgba(0, 0, 0, 0.525) 75%, rgba(0, 0, 0, 0.7) 100%)'
                }}
              />
              <div className="absolute bottom-5 w-full text-center font-semibold text-lg drop-shadow-md text-white">
                <Link
                  onClick={() => scrollToTop()}
                  to="/donation"
                  className="text-white"
                >
                  {data.text}
                </Link>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}

export default Cardslider;